'use client';

import { useEffect } from 'react';
import NextError from 'next/error';
import posthog from 'posthog-js';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error }: Props) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
